export const WISE_ALIAS = 'wise';
